
import draggable from 'vuedraggable';

export default {
  components: {
    draggable: draggable
  },
  props: {
    defaultConfig: {
      type: Array,
      required: true
    },
    minItems: {
      type: Number,
      default: 0
    },
    maxItems: {
      type: Number,
      default: 100
    },
    options: {
      type: Array,
      required: true
    },
    addable: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    },
    unique: {
      type: Boolean,
      default: true
    },
    sortable: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      innerConfig: null
    };
  },


  computed: {
    showAddBtn: function showAddBtn() {
      if (this.addable) {
        return this.unique ? this.defaultConfig.length < Math.min(this.options.length, this.maxItems) : this.defaultConfig.length < this.maxItems;
      }
      return false;
    },
    showRemoveBtn: function showRemoveBtn() {
      if (this.removable) {
        return this.defaultConfig.length > this.minItems;
      }
      return false;
    }
  },

  watch: {
    defaultConfig: function defaultConfig(val) {
      this.innerConfig = this.defaultConfig.map(function (item) {
        return {
          value: item
        };
      });
    }
  },

  mounted: function mounted() {
    this.innerConfig = this.defaultConfig.map(function (item) {
      return {
        value: item
      };
    });
  },


  methods: {
    change: function change() {
      this.$emit('change', {
        conf: this.innerConfig.map(function (item) {
          return item.value;
        })
      });
    },
    handleSelectChange: function handleSelectChange(value, index) {
      this.innerConfig[index].value = value;
      this.$emit('change', {
        conf: this.innerConfig.map(function (item) {
          return item.value;
        })
      });
    },


    // 如果unique为true，则不允许重复选项
    optionDisabled: function optionDisabled(item, index) {
      if (this.unique) {
        return this.defaultConfig.indexOf(item.value) !== -1 && this.defaultConfig.indexOf(item.value) !== index;
      }
      return false;
    },
    addItem: function addItem() {
      var _this = this;

      if (this.unique) {
        this.innerConfig.push({
          value: this.options.find(function (e) {
            return _this.defaultConfig.indexOf(e.value) === -1;
          }).value
        });
        this.change();
      } else {
        this.innerConfig.push({
          value: this.options[0].value
        });
        this.change();
      }
    },
    removeItem: function removeItem(index) {
      this.innerConfig.splice(index, 1);
      this.change();
    }
  }
};